import { MarketingBanner } from '@barges/react';
import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { isXfmProgram } from '@app/config/util';
import { toCamelCase } from '../config/utils';
import MarketingImage from './marketing_img/marketing_image';
import classes from './classes.module.scss';

import '@barges/scss/lib/title.css';
import '@barges/scss/lib/marketing-banner.css';

const TopBanner = ({
  topBannerProps,
  overlay = false
}) => {
  const {
    bonusInfos = [], userBonusInfos = [], userXfmProgram = null, userId, shouldShowMarketingBanner = true, xfmFreeSetupMin, xfmDefaultMinutes, isPrerenderMode
  } = topBannerProps || {};
  const { t } = useTranslation();

  const [showTopBanner, setShowTopBanner] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowTopBanner(true), 100); // Need for fix hydration error
  }, []);

  const shouldShowXFMBanner = () => isXfmProgram({ userXfmProgram });

  const freeMinutesText = () => {
    const minutesCount = xfmFreeSetupMin;
    const advisorsCount = userXfmProgram?.credits ?? xfmDefaultMinutes;

    const minutesText = minutesCount > 1 ? t('enjoy_free_minutes.minutes') : t('enjoy_free_minutes.minute');
    const advisorsText = advisorsCount > 1 ? t('enjoy_free_minutes.advisors') : t('enjoy_free_minutes.advisor');

    // XFM sessions run as free setup time and don't bump the order counters, so "first reading"
    // is detected by the user still holding the full default credit allotment (nothing spent yet).
    const isFirstReading = advisorsCount === xfmDefaultMinutes;

    if (advisorsCount === 1 && isFirstReading) {
      return (
        <Trans
          i18nKey="enjoy_free_minutes.enjoy_free_minutes_first_reading"
          values={ { minutesCount, minutesText } }
        />
      );
    }

    return (
      <Trans
        i18nKey= "enjoy_free_minutes.enjoy_free_minutes"
        values={ {
          minutesCount, advisorsCount, minutesText, advisorsText
        } }
      />
    );
  };

  const getActiveOffers = () => {
    if (userId) return userBonusInfos;
    return bonusInfos;
  };

  const generateMarketingBannerArray = () => {
    if (!shouldShowMarketingBanner) return [];
    const activeOffers = getActiveOffers();
    let offers = [];
    if (activeOffers?.length > 0) {
      const offer = toCamelCase(activeOffers[0]);
      offers = [{ title: offer.specialOffer ?? '', subtitle: offer.bonusText  ?? '' }];
    }
    if (shouldShowXFMBanner()) {
      offers.push({ title: freeMinutesText() });
    }
    return offers;
  };

  const offers = generateMarketingBannerArray();

  if (!offers?.length || isPrerenderMode || !showTopBanner) return null;

  return (
    <div className={ `${ classes.topBannerContainer } ${ overlay ? classes.topBannerContainerOverlay : '' }` }>
      <MarketingBanner
        offers={ offers }
        offerIcon={ <MarketingImage offers={ offers } /> }
      />
    </div>
  );
};

export default TopBanner;
